/**
 * Canonical public site origin for redirects, emails, and metadata.
 * Prefer NEXT_PUBLIC_SITE_URL in all deployed environments so links match the real host.
 */
const DEFAULT_PROD = "https://aptinomic.com";

export function getPublicSiteUrl(): string {
  const raw = process.env.NEXT_PUBLIC_SITE_URL?.trim();
  if (raw) return raw.replace(/\/$/, "");
  return DEFAULT_PROD;
}

/**
 * Browser-only: env URL when set, otherwise current origin (local dev).
 */
export function getBrowserSiteOrigin(): string {
  const env = process.env.NEXT_PUBLIC_SITE_URL?.trim();
  if (env) return env.replace(/\/$/, "");
  if (typeof window !== "undefined") return window.location.origin;
  return DEFAULT_PROD;
}

export function absoluteUrl(path: string): string {
  const base = getPublicSiteUrl();
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${base}${p}`;
}
